import { PartyAttendeeItemProps } from "../interfaces/PartyAttenndeesInterface";
import { PartyItemProps } from "../interfaces/PartyInterface";
import { AxiosInstance } from "axios";
import BaseUseCase from "../lib/BaseUseCase";
import { CREATE_PARTY_PATH, REQUEST_JOIN_PARTY_PATH } from "../lib/path";

class PartyUseCase extends BaseUseCase {
  constructor(client: AxiosInstance) {
    super(client);
  }

  async getAllPartiesOfActivity(activityId) {
    try {
      const response = await this.client.get(CREATE_PARTY_PATH, {
        params: { activityId },
      });
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }

  async requestJoinParty(partyId: number) {
    const jwtToken = sessionStorage.getItem("jwtToken");
    const userId = parseInt(sessionStorage.getItem("userId"));
    const config = {
      headers: { "user-id": userId, Authorization: `Bearer ${jwtToken}` },
    };

    try {
      const response = await this.client.post(
        REQUEST_JOIN_PARTY_PATH,
        {
          party_id: partyId,
        },
        config
      );
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }

  getActivityIds(): { activityIds: Array<string> } {
    return {
      activityIds: ["1"],
    };
  }
}

export default PartyUseCase;
